import styled from 'styled-components';

import { ReactComponent as ArrowIcon } from 'assets/icons/collapse-down.svg';

import { COLOR } from 'constants/color';

export const CollapseHeader = styled.header<{ isOpen: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin-bottom: 12px;
`;

export const CollapseHeaderTitle = styled.h3`
  font-size: 14px;
  line-height: calc(20 / 14);
  color: ${COLOR.surfaceNeutralBold['neutral-11']};
  font-weight: 600;
  margin: 0;
`;

export const CollapseBody = styled.div<{ isOpen: boolean }>`
  max-height: ${({ isOpen }) => (isOpen ? '100%' : '0')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  overflow: hidden;
  transition:
    max-height 0.5s ease,
    opacity 0.5s ease;
`;

export const Arrow = styled(ArrowIcon)<{ isOpen: boolean }>`
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.3s ease;
`;
